<template>
  <div>
    <div class="w3-modal" :class="{'show':modal === 1}">
      <div class="w3-modal-content">
        <div class="top-bar primary">
          <button class="w3-button" style="margin: 6px" @click="() => {modal = 0; term = ''}">
            <span class="w3-small">Cancelar</span>
          </button>
        </div>
        <div class="w3-padding w3-padding-16 w3-small">
          <div>
            <label :for="input"><b>Selecione uma pessoa</b></label>
            <div style="position: relative;">
              <i class="fa fa-times w3-padding" @click="limparSearch(input)" style="position: absolute; right: 6px; top: 3px; cursor: pointer" v-show="term.trim() !== ''"></i>
              <input type="text" class="w3-input w3-border" :id="input" v-model="term"
                     @keyup="pesquisar()"
                     @keyup.enter="searchResults.length === 1 ? selecionar(searchResults[0]) : ''"
                     placeholder="Nome ou email.."
                     autocomplete="new-street-address">
            </div>
          </div>

          <div class="w3-margin-top">
            <div class="w3-border box-container" v-show="term.trim() !== ''">
              <a href="javascript:" class="w3-padding w3-padding-16 w3-block w3-border-bottom" v-for="r in searchResults" @click="selecionar(r)">
                {{r.nome}}
              </a>

              <div class="w3-display-middle w3-center" v-show="searchResults.length === 0">
                <i class="fa fa-frown-o fa-2x w3-padding"></i> <br>
                Não encontrado resultados!
              </div>

            </div>

            <div class="w3-border box-container" v-show="term.trim() === ''">
              <a href="javascript:" class="w3-padding w3-padding-16 w3-block w3-border-bottom" v-for="r in usuarios" @click="selecionar(r)">
                {{r.nome}}
              </a>
            </div>

          </div>
        </div>
      </div>
    </div>

    <div class="w3-modal" :class="{'show': modal === 2}">
      <div class="w3-modal-content">
        <div class="top-bar primary w3-small">
          <button class="w3-button" style="margin: 6px" @click="modal = false">
            Cancelar
          </button>
          <button class="w3-button w3-right" style="margin: 6px" @click="enviarPagamento">
            Enviar Pagamento
          </button>
        </div>
        <div class="w3-row-padding w3-small">
          <div class="w3-col m12">
            <h6 class="w3-center w3-padding-16"><b>ENVIAR PAGAMENTO</b></h6>
            <div style="margin-bottom: 32px">
              <div class="w3-row">
                <div class="w3-col m12 w3-margin-top">
                  <label><b>Pagamentos</b></label>
                  <select class="w3-select w3-white w3-border" v-model="dados.forma_pagamento">
                    <option value="0">Selecione uma forma de pagamento</option>
                    <option :value="f.id_pagamento" v-for="f in formas_pagamento">{{f.nome_pagamento}}</option>
                  </select>
                </div>
                <div class="w3-col m12 w3-margin-top">
                  <label><b>Valor</b></label>
                  <money v-model="dados.valor_pagamento" v-bind="money" class="w3-input w3-border"/>
                </div>
                <div class="w3-col m12 w3-margin-top">
                  <button class="w3-button primary w3-block w3-round" @click="enviarPagamento">Enviar Pagamento</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import {Money} from 'v-money'
  export default {
    name: "inserir",
    components: {Money},
    data() {
      return {
        modal: 0,
        token: localStorage.getItem('key'),
        term: '',
        usuarios: [],
        searchResults: [],
        formas_pagamento: [],

        input: ID(),
        dados: {
          id_usuario: '',
          valor_pagamento: 0,
          forma_pagamento: 0,
          obs_pagamento: ''
        },

        money: {
          decimal: '.',
          thousands: '',
          prefix: 'R$ ',
          suffix: '',
          precision: 2,
          masked: false
        },
      }
    },

    methods: {
      buscarUsuarios() {
        openLoading("Buscando Usuarios");

        this.$http.get(base_url + 'usuarios/' + this.token)
          .then(response => {
            this.usuarios = response.data;
            closeLoading();

          }, res => {
            console.log(res);
            closeLoading();
            openModalMsg(res.data.result, res.data.msg, true);
          });
      },

      buscarFormasPagamento() {
        this.$http.get(base_url + 'formas-pagamentos/' + this.token)
          .then(response => {
            this.formas_pagamento = response.data;
            closeLoading();

          }, res => {
            closeLoading();
            openModalMsg(res.data.result,res.data.msg);
          });
      },

      pesquisar() {
        let keys = [
          "nome",
          "email"
        ];

        let options = {
          shouldSort: true,
          threshold: 0.2,
          location: 0,
          distance: 100,
          maxPatternLength: 32,
          minMatchCharLength: 1,
          keys: keys
        };

        this.$search(this.term, this.usuarios, options).then(results => {
          this.searchResults = results;
        })
      },

      limparSearch() {
        this.term = '';
      },

      selecionar(u) {
        this.dados.id_usuario = u.id_usuario;
        this.modal = 2;
      },

      enviarPagamento() {
        if (this.dados.forma_pagamento === 0) {
          openModalMsg("Atenção!", "Selecione uma forma de pagamento.");
          return;
        }

        if (this.dados.valor_pagamento <= 0) {
          openModalMsg("Atenção!", "Informe um valor válido para o pagamento.");
          return;
        }

        let url = base_url + 'transacoes/pagar-amigo/' ;
        openLoading("Enviando Pagamento");

        this.$http.post(url + this.token, this.dados, {emulateJSON: true})
          .then(response => {
            closeLoading();

            console.log(response);
            if (response.data.result && response.data.result  === 'success') {
              this.modal = false;
              openModalMsg("Pagamento enviado!", "Assim que seu pagamento for aprovado, atualizaremos o saldo do seu amigo.");
              this.$emit('atualizar');
            }

          }, res => {
            closeLoading();
            console.log(res);
            openModalMsg(res.data.result, res.data.msg);
          });

      },

    },

    created() {
      this.$parent.$on('openModal', () => {
        this.modal = 1
      });
    },

    mounted() {
      this.buscarUsuarios();
      this.buscarFormasPagamento();
    },

    filters: {
      valor(value) {
        if (value !== null || value !== undefined) {
          return parseFloat(value).toFixed(2);
        }
      },

      fixed(value) {
        if (value !== null || value !== undefined) {
          return parseFloat(value).toFixed();
        }
      }
    }

  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/commons/PagarAmigo.vue